import React from 'react'
import { ComponentCSSProp } from '@grupoboticario/flora-react-system'
import { Box } from '@grupoboticario/flora-react-box'
import { ColorThemeProps } from '@grupoboticario/flora'
import { filterUndefined } from '@grupoboticario/flora-react-utils'

export type IconWrapperProps = {
  size?: number | string
  color?: ColorThemeProps
  children?: React.ReactNode
} & ComponentCSSProp

export const IconWrapper = React.forwardRef<React.ElementRef<typeof Box>, IconWrapperProps>(
  ({ color = 'currentColor', children, size = 24, ...props }, forwardedRef) => {
    const sizeProps = {
      width: size,
      height: size,
    }

    const css = filterUndefined({
      ...(props.css as any),
      '& > svg, & path': {
        fill: color,
      },
      display: 'inline-flex',
    })

    return (
      <Box ref={forwardedRef} css={css} as="span">
        {React.cloneElement(children as any, {
          ...(children as any)?.props,
          ...props,
          ...sizeProps,
        })}
      </Box>
    )
  },
)
